export default __webpack_public_path__ + "static/media/backtracking.e10eb01e.png";